import { IPlanDocument } from "../../api/config/models/plan";
import { IPlan, ISolfanameData } from "../types";

export const getScaleAndTempo = (plan: IPlan | IPlanDocument, index: number) => {
    const task = plan.tasks[index];
    let { scale, tempo } = task.data as ISolfanameData;
    if (!scale && task.ref && task.type !== "melodyTable") {
        scale = plan.scores.find(score => score._id.toString() === task.ref)!.scale || 1;
    }
    if (!tempo && task.ref) {
        tempo = plan.scores.find(score => score._id.toString() === task.ref)!.tempo || 60;
    }

    return { tempo, scale };
}
